import { config } from '../config';

export const initHeap = () => {
    const { environment } = config;

    if (environment === 'production') {
        window.heap.load('2925581908');
    } else if (environment === 'staging') {
        window.heap.load('3241829472');
    } else {
        window.heap.load('1660434097');
    }
};
